import { dsl } from '@wix/yoshi-serverless/wrap';

export const eligibleOrders = dsl({
          functionName: 'eligibleOrders',
          fileName: 'api/benefits/eligibleOrders.api',
        });